export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f68289b7306c81b34785d191e241aada027e251a6&name=fetchTypeahead!'